import {
    DELETE_JOB_OFFER_SUCCESS,
    GET_JOB_OFFER_SUCCESS,
    GET_JOB_OFFERS_SUCCESS,
    SET_JOB_OFFER_STATE, UPDATE_APPLICATION_FLOW_SUCCESS, UPDATE_APPLICATION_TIME_SUCCESS, UPSERT_JOB_OFFER_SUCCESS,
    JOB_OFFER_FICHE_SUCCESS, GET_JOB_OFFERS_COUNT_SUCCESS, GET_JOB_OFFERS_COUNT,
    JOB_OFFER_PROPOSAL_SUCCESS, JOB_OFFER_CONTRACT_SUCCESS, JOB_OFFER_CONTRACT_SIGN_SUCCESS,
    JUST_JOB_OFFER_PROPOSAL, JOB_OFFER_CONTRACT_PROPOSAL_SUCCESS,
    GET_TALENTS_BY_JOB_OFFER_REQUEST,
    GET_TALENTS_BY_JOB_OFFER_SUCCESS,
    GET_TALENTS_BY_JOB_OFFER_FAILURE,
    SEND_JOB_OFFER_LINK_REQUEST,
    SEND_JOB_OFFER_LINK_SUCCESS,
    SEND_JOB_OFFER_LINK_FAILURE,
    GET_JOB_OFFERS_LIST_REQUEST,
    GET_JOB_OFFERS_LIST_SUCCESS,
    GET_JOB_OFFERS_LIST_FAILURE,
    GET_HISTORY_TALENT_REQUEST,
    GET_HISTORY_TALENT_SUCCESS,
    GET_HISTORY_TALENT_FAILURE,
    JOB_OFFER_INTERVIEW_JOINED_SUCCESS,
    REMIND_TALENT_LATE_REQUEST,
    REMIND_TALENT_LATE_SUCCESS,
    REMIND_TALENT_LATE_FAILURE,
    CANCEL_OTHER_INTERVIEWS,
    CANCEL_OTHER_INTERVIEWS_SUCCESS,
    FETCH_SHARED_JOB_OFFERS_REQUEST,
    FETCH_SHARED_JOB_OFFERS_SUCCESS,
    FETCH_SHARED_JOB_OFFERS_FAILURE,
    SHOW_GUIDE_COLLABORATION,
    FETCH_JOB_OFFER_PREVIEW_START,
    FETCH_JOB_OFFER_PREVIEW_SUCCESS,
    FETCH_JOB_OFFER_PREVIEW_ERROR,
    SEARCH_JOB_OFFERS_SUCCESS,
    SEARCH_JOB_OFFERS_COUNT_SUCCESS,
} from '../action-types'

const INIT_STATE = {
    job_offer: null,
    job_offers: [],
    searchJobOffers: [],
    proposals: [],
    contract: null,
    job_offer_fiche: null,
    paginator: {
        currentPage: 1,
        lastPage: 1,
        total: 0
    },
    searchPaginator: {
        currentPage: 1,
        lastPage: 1,
        total: 0
    },
    paginatorCount: {
        currentPage: 1,
        lastPage: 1,
        total: 0
    },
    searchPaginatorCount: {
        currentPage: 1,
        lastPage: 1,
        total: 0
    },
    paginatorCountLoading: false,
    searchPaginatorCountLoading: false,
    presentation: "",
    contract_application: null,
    applications: [],
    paginatorInfo: null,
    countStatus: {},
    loading: false,
    error: null,
    jobOffersList: null,
    historiesList: [],
    SharedLinkList: [],
    changeGuideCollaboration: 1,
    isPreviewLoading: false,
    previewData: null,
}

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case FETCH_SHARED_JOB_OFFERS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_SHARED_JOB_OFFERS_SUCCESS:
            return { ...state, loading: false, SharedLinkList: action.payload };
        case FETCH_SHARED_JOB_OFFERS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case REMIND_TALENT_LATE_REQUEST:
            return { ...state, loading: true, error: null };
          case REMIND_TALENT_LATE_SUCCESS:
            return { ...state, loading: false };
          case REMIND_TALENT_LATE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SEND_JOB_OFFER_LINK_REQUEST:
            return { ...state, loading: true, error: null };

        case SEND_JOB_OFFER_LINK_SUCCESS:
            return { ...state, loading: false };

        case SEND_JOB_OFFER_LINK_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_TALENTS_BY_JOB_OFFER_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_TALENTS_BY_JOB_OFFER_SUCCESS:

            return {
                ...state,
                loading: false,
                applications: action.payload.data,
                paginatorInfo: action.payload.paginatorInfo,
                countStatus: action.payload.countStatus,
                //job_offer: action?.payload.data[0]?.jobOffer
            };
        case GET_HISTORY_TALENT_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_HISTORY_TALENT_SUCCESS:
            return { ...state, loading: false, historiesList: action.payload };
        case GET_HISTORY_TALENT_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_JOB_OFFERS_LIST_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_JOB_OFFERS_LIST_SUCCESS:
            return { ...state, loading: false, jobOffersList: action.payload };

        case GET_JOB_OFFERS_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case GET_TALENTS_BY_JOB_OFFER_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_JOB_OFFERS_SUCCESS: {
            return {...state, job_offers: action?.data?.job_offers, paginator: action?.data?.job_offers?.paginatorInfo, paginatorCount: action?.data?.job_offers?.paginatorInfo}
        }

        case GET_JOB_OFFERS_COUNT: {
            return {...state, paginatorCountLoading: true}
        }

        case GET_JOB_OFFERS_COUNT_SUCCESS: {
            return {...state, paginatorCount: action?.data?.job_offers?.paginatorInfo, paginatorCountLoading: false}
        }

        case GET_JOB_OFFER_SUCCESS: {
            return {...state, job_offer: action?.data?.jobOfferById}
        }

        case JOB_OFFER_FICHE_SUCCESS: {
            return {...state, job_offer_fiche: action?.data}
        }

        case DELETE_JOB_OFFER_SUCCESS: {
            let deletedId = action?.data?.deleteJobOffer?.id
            if(deletedId) {
                state.job_offers.data = state.job_offers.data.filter((job_offer) => job_offer.id !== deletedId)
            }

            return {...state }
        }

        case UPSERT_JOB_OFFER_SUCCESS: {
            let updatedJobOffer = action?.data?.data?.upsertJobOffer || state.job_offer

            return {...state, job_offer: updatedJobOffer}
        }

        case JOB_OFFER_PROPOSAL_SUCCESS: {
            return {...state, proposals: action?.data}
        }

        case JOB_OFFER_CONTRACT_SUCCESS: {
            return {...state, contract: action?.data}
        }

        case JOB_OFFER_CONTRACT_SIGN_SUCCESS: {
            return {...state, contract: null}
        }

        case JUST_JOB_OFFER_PROPOSAL: {
            let talentProposals = state.proposals;

            for (let i = 0; i < state.proposals.length; i++) {
                if (state.proposals[i].id == action?.data?.id) {
                    talentProposals[i] = action?.data;
                    break;
                }
            }
            talentProposals = JSON.parse(JSON.stringify(talentProposals))

            return {...state, proposals: talentProposals}
        }

        case SET_JOB_OFFER_STATE: {
            return {
                ...state,
                ...action?.payload
            }
        }

        case UPDATE_APPLICATION_TIME_SUCCESS:{
            let indexJob = ''
            let indexApplication = ''

            for (let i = 0; i < state.job_offers?.data?.length; i++) {
                if (state.job_offers.data[i].applications) {
                    for (let j = 0; j < state.job_offers.data[i].applications.length; j++) {
                        if (state.job_offers.data[i].applications[j].id == action.data.id) {
                            indexJob = i
                            indexApplication = j
                            break
                        }
                    }
                }
            }

            let copyJobOffers = state.job_offers;
            if (indexJob !== '' && indexApplication !== '') {
                copyJobOffers.data[indexJob].applications[indexApplication].step = action.data.step;
                copyJobOffers.data[indexJob].applications[indexApplication].status = action.data.status;
                if (action.data.times) {
                    copyJobOffers.data[indexJob].applications[indexApplication].times = action.data.times;
                }
            }

            return {...state, job_offers: copyJobOffers}
        }

        case UPDATE_APPLICATION_FLOW_SUCCESS: {
            let indexJob = ''
            let indexApplication = ''
            console.log(action.data, state.applications)

            for (let i = 0; i < state.applications?.length; i++) {
                if (state.applications[i].id == action.data.id) {
                    indexApplication = i
                    break
                }
            }

            let copyApplications = JSON.parse(JSON.stringify(state.applications));
            copyApplications[indexApplication] = action.data;

            return {...state, applications: copyApplications}
        }

        case JOB_OFFER_CONTRACT_PROPOSAL_SUCCESS: {
            return {...state, contract_application: action.data}
        }

        case CANCEL_OTHER_INTERVIEWS_SUCCESS: {
            return state
        }

        case SHOW_GUIDE_COLLABORATION: {
            return {...state, changeGuideCollaboration: state.changeGuideCollaboration + 1}
        }

        case FETCH_JOB_OFFER_PREVIEW_START:
            return {
                ...state,
                isPreviewLoading: true
            };
            
        case FETCH_JOB_OFFER_PREVIEW_SUCCESS:
            return {
                ...state,
                isPreviewLoading: false,
                previewData: action.payload
            };
            
        case FETCH_JOB_OFFER_PREVIEW_ERROR:
            return {
                ...state,
                isPreviewLoading: false,
                previewData: null
            };

        case SEARCH_JOB_OFFERS_SUCCESS: {
            return {...state, searchJobOffers: action?.data?.job_offers, searchPaginator: action?.data?.job_offers?.paginatorInfo, searchPaginatorCount: action?.data?.job_offers?.paginatorInfo}
        }

        case SEARCH_JOB_OFFERS_COUNT_SUCCESS: {
            return {...state, searchPaginatorCount: action?.data?.job_offers?.paginatorInfo, searchPaginatorCountLoading: false}
        }

        default:
            return state
    }
}
